import {useEffect, useState} from 'react'

import logo from 'assets/logo.svg'
import Signin from './components/Signin'
import Signup from './components/Signup'
import LanguageSelect from './components/LanguageSelect'
import NavButton from './components/NavButton'
import {landingLink} from '../common/core/constants'
import {AuthStage} from '../common/core/entities'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router-dom'

const AuthPage = () => {
    const [stage, setStage] = useState<AuthStage>('signup')
    const {stage: stageParam} = useParams()
    const navigate = useNavigate()
    const {t} = useTranslation()

    useEffect(() => {
        if (stageParam === 'signin') {
            setStage('signin')
            return
        }
        if (stageParam === 'signup') {
            return
        }

        navigate('/auth/signup')
    }, [navigate, stageParam])

    const onClickStageButtons = (as: AuthStage) => () => {
        setStage(as)
    }

    const redirectToLanding = () => {
        window.location.href = landingLink
    }

    return (
        <div className={`flex h-full w-full overflow-x-hidden bg-yellow-40`}>
            <div className="grid min-h-0 w-[35rem] grid-rows-5">
                <div className="row-span-2 flex items-center px-24">
                    <img
                        className="w-full cursor-pointer"
                        src={logo}
                        alt="no coins"
                        onClick={redirectToLanding}
                    />
                </div>
                <div className="row-span-1 flex flex-col items-end text-3xl font-bold text-white">
                    <NavButton
                        title={t('AUTH_SIGNIN_OPTION')}
                        active={stage === 'signin'}
                        onClick={onClickStageButtons('signin')}
                    />
                    <NavButton
                        title={t('AUTH_SIGNUP_OPTION')}
                        active={stage === 'signup'}
                        onClick={onClickStageButtons('signup')}
                    />
                </div>
                <div className="row-span-2 flex flex-col items-center justify-center text-center font-bold text-white">
                    <div className="text-[3rem]">{t('AUTH_CASHLESS_TIPS')}</div>
                    <div className="text-[1.75rem] font-light">
                        {t('AUTH_UP_TO_40')}
                    </div>
                </div>
            </div>
            <div className="flex flex-1 flex-col items-center overflow-auto rounded-l-[60px] bg-white py-3">
                <div className="flex w-60 shrink-0 self-end pt-3 pr-3">
                    <LanguageSelect />
                </div>
                <div className="flex flex-1 items-center justify-center">
                    {stage === 'signin' ? <Signin /> : <Signup />}
                </div>
            </div>
        </div>
    )
}

export default AuthPage
